import { render, staticRenderFns } from "./OrderHistoryTab.vue?vue&type=template&id=4e4a4c82&scoped=true"
import script from "./OrderHistoryTab.vue?vue&type=script&lang=js"
export * from "./OrderHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryTab.vue?vue&type=style&index=0&id=4e4a4c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a4c82",
  null
  
)

export default component.exports